import React from "react"
import "./style.scss"
import logo1 from "./dataconnection-icons/Connections Facebook.png"
import logo2 from "./dataconnection-icons/ConnectionsA.png"
import logo3 from "./dataconnection-icons/ConnectionsAmazon.png"
import logo4 from "./dataconnection-icons/ConnectionsAWIN.png"
import logo5 from "./dataconnection-icons/ConnectionsDrive.png"
import logo6 from "./dataconnection-icons/ConnectionsDropbox.png"
import logo7 from "./dataconnection-icons/ConnectionsEbay.png"
import logo8 from "./dataconnection-icons/ConnectionsEtsy.png"
import logo9 from "./dataconnection-icons/ConnectionsFB Ads.png"
import logo10 from "./dataconnection-icons/ConnectionsGoogle ai.png"
import logo11 from "./dataconnection-icons/ConnectionsGoogle analytics.png"
import logo12 from "./dataconnection-icons/ConnectionsInsta.png"
import logo13 from "./dataconnection-icons/ConnectionsLinked In.png"
import logo14 from "./dataconnection-icons/ConnectionsMarketto.png"
import logo15 from "./dataconnection-icons/ConnectionsNew egg.png"
import logo16 from "./dataconnection-icons/ConnectionsOffice365.png"
import logo17 from "./dataconnection-icons/ConnectionsSalesforce.png"
import logo18 from "./dataconnection-icons/ConnectionsShopee.png"
import logo19 from "./dataconnection-icons/ConnectionsSnapchat.png"
import logo20 from "./dataconnection-icons/ConnectionsTwitter.png"
import logo21 from "./dataconnection-icons/ConnectionsWalmart.png"
import logo22 from "./dataconnection-icons/Connectionsweaveroo.png"
import logo23 from "./dataconnection-icons/GBQ.png"
import logo24 from "./dataconnection-icons/csvIcon.png"
import logo25 from "./dataconnection-icons/postgreSQL.png"
import logo26 from "./dataconnection-icons/amazonRedshift.png"
import logo27 from "./dataconnection-icons/amazonElastic.png"
import logo28 from "./dataconnection-icons/oracleDB.png"
import logo29 from "./dataconnection-icons/mySQL.png"
import logo30 from "./dataconnection-icons/msSQL.png"
import logo31 from "./dataconnection-icons/mongoDB.png"
import logo32 from "./dataconnection-icons/mapr.png"
import logo33 from "./dataconnection-icons/Hive.png"
import logo34 from "./dataconnection-icons/hadoop.png"
import logo35 from "./dataconnection-icons/elastic.png"
import logo36 from "./dataconnection-icons/azureDL.png"

import {
	makeStyles,
  useTheme,
  useMediaQuery,
} from '@material-ui/core'

const useStyles = makeStyles((theme)=>({
  scrollContent: {
    maxWidth: '100%',
    padding: '5px 5px',
  },
}))

const DataConnectionsSection = () => {

  const classes = useStyles()

  let list = [
    {
      logo: logo1,
    },
    {
      logo: logo2,
    },
    {
      logo: logo3,
    },
    {
      logo: logo4,
    },
    {
      logo: logo5,
    },
    {
      logo: logo6,
    },
    {
      logo: logo7,
    },
    {
      logo: logo8,
    },
    {
      logo: logo9,
    },
    {
      logo: logo10,
    },
    {
      logo: logo11,
    },
    {
      logo: logo12,
    },
    {
      logo: logo13,
    },
    {
      logo: logo14,
    },
    {
      logo: logo15,
    },
    {
      logo: logo16,
    },
    {
      logo: logo17,
    },
    {
      logo: logo18,
    },
    {
      logo: logo19,
    },
    {
      logo: logo20,
    },
    {
      logo: logo21,
    },
    {
      logo: logo22,
    },
    {
      logo: logo23,
    },
    {
      logo: logo24,
    },
    {
      logo: logo25,
    },
    {
      logo: logo26,
    },
    {
      logo: logo27,
    },
    {
      logo: logo28,
    },
    {
      logo: logo29,
    },
    {
      logo: logo30,
    },
    {
      logo: logo31,
    },
    {
      logo: logo32,
    },
    {
      logo: logo33,
    },
    {
      logo: logo34,
    },
    {
      logo: logo35,
    },
    {
      logo: logo36,
    },
  ]

  const returnDataConnections = () => {
    return list.map((item, key) => (
      <div
      // className={classes.scrollContent}
        className="columnContainer col-lg-3 col-md-3 col-sm-6 col-xs-6"
        key={key}
      >
        <div className=" card scrolling-card">
          <div className="logo">
            <img src={item.logo} alt="logo" />
          </div>
        </div>
      </div>
    ))
  }
  return (
    <div className="homepage_dataconnectionSection">
      {/* <div className="text-area">
        <h4 className="title">Harness The Power of Data-Driven Decisions</h4>
        <hr className="titleLine"/>
        <p className="text">
          {" "}
          Decisions that are data-driven are always efficient and work best in the employee’s favour. Wersel offers an in-depth analysis of employees’ long-term and short-term performance. In addition, businesses can also identify the level of efficiency in their employees. The insights into these data can be utilised to make decisions for employees. Those decisions will be more efficient and right because they are data-driven. The effects of those decisions will also be positive because they are based on reality. For example, during the compensation phase of employees, HRs can analyse the performance  of the employees. They can then distribute the appraisals based on the performance. Since the compensation distribution will be based on datadriven decisions, they are reliable and accurate.
          <br />
          <br />
        </p>
      </div> */}
      <div className="scrollViewer">
        <div className="container-fluid scrollContent">
          <div className="row">{returnDataConnections()}</div>
          <div className="row">{returnDataConnections()}</div>
        </div>
      </div>
    </div>
  )
}
export default DataConnectionsSection
